import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'partialString'
})
export class PartialStringPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    const size = args[0] as number;
    return value.substring(0, size);
  }

}
